



























import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ModalWindow extends Vue {
  @Prop({ default: 0 }) private timer!: number;

  @Prop({ default: false }) private sideModal!: boolean;

  currentTimer = 0;

  show = true;

  mounted(): void {
    if (this.timer) this.currentTimer = this.timer;
    if (this.currentTimer > 0) {
      const modalTimer = setInterval(() => {
        this.currentTimer -= 0.1;
        if (this.currentTimer <= 0) {
          clearInterval(modalTimer);
          this.closeModal();
        }
      }, 100);
    }
  }

  @Watch('timer') onTimerChange(): void {
    this.currentTimer = this.timer;
  }

  get timerWidth(): number {
    const percent = this.timer / 100;
    return (this.timer - this.currentTimer) / percent;
  }

  closeModal(): void {
    this.$emit('close-modalWindow');
  }
}
